// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__3NqeR","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__11nGe"};